import { URLS } from 'api/constants';
import {
  IBlogPost,
  ICasino,
  IExtendedCollection,
  INews,
  IProvider,
  ISlot,
  ICasinoReview,
  ISlotReview,
} from 'constants/types';
import { apiGet } from './client';

export interface HomeData {
  news?: INews[];
  guides?: IBlogPost[];
  allSlots: ISlot[];
  allProviders: IProvider[];
  newsCount: number;
  allCasinos: ICasino[];
  guidesCount: number;
  latestReviews: ICasinoReview[];
  latestSlotReviews: ISlotReview[];
  lastSlotReviewsCount: number;
  allSlotsCount: number;
  allCasinosCount: number;
  allProvidersCount: number;
  lastReviewsCount: number;
  slotsCollections: IExtendedCollection[];
  casinoCollections: IExtendedCollection[];
}

export type Home = HomeData;

export async function getHome(region: string | null) {
  return apiGet<HomeData>(URLS.HOME, { reg: region ?? '' });
}
